import { TextareaHTMLAttributes, forwardRef, useState } from 'react';

import cx from 'classnames';

type QuestionFormTextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export default forwardRef<HTMLTextAreaElement, QuestionFormTextareaProps>(
  function QuestionFormTextarea({ className, children, ...props }, ref) {
    const [count, setCount] = useState<number>(0);
    const MAX_LENGTH = 300;

    return (
      <>
        <textarea
          ref={ref}
          {...props}
          rows={5}
          maxLength={MAX_LENGTH}
          onChange={e => {
            setCount(e.target.value.length);

            if (props.onChange) {
              props.onChange(e);
            }
          }}
          className={cx(
            className,
            'appearance-none border border-blue-20 w-full py-2 px-3 text-grey-80 leading-tight focus:outline-none focus:shadow-outline',
          )}
        >
          {children}
        </textarea>
        <span className="flex justify-end text-sm text-grey-80">
          {count} / {MAX_LENGTH}
        </span>
      </>
    );
  },
);
